// extracted by mini-css-extract-plugin
export default {"text":"HintFindOpeningFolder_text__-EWKp"};